'use client';

import {Button} from '@purpose/ui/components/button';
import {PlusIcon} from 'lucide-react';
import Image from 'next/image';

interface CategoryCardSmallProps {
  width?: number;
  image: string;
  title?: string;
  description?: string;
  onClick: () => void;
  onButtonClick: () => void;
}

const CategoryCardSmall = ({
  width,
  image,
  title,
  description,
  onClick,
  onButtonClick
}: CategoryCardSmallProps) => {
  return (
    <div
      style={{
        width: typeof width === 'string' ? width : `${width || 292}px`,
        borderRadius: '16px',
        cursor: 'pointer',
        display: 'flex',
        gap: '24px',
        overflow: 'hidden',
        position: 'relative',
        padding: '16px 24px 16px 12px',
        backgroundColor: '#ffffffff',
        justifyContent: 'space-between'
      }}
      onClick={onClick}
    >
      <div
        style={{
          display: 'flex',
          gap: '24px',
          position: 'relative',
          flexDirection: 'row'
        }}
      >
        <Image
          width={80}
          height={80}
          src={image}
          alt={title || 'card image'}
          style={{borderRadius: '4px'}}
        />
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            gap: '4px',
            padding: '8px 0'
          }}
        >
          {title && (
            <h3
              style={{
                margin: 0,
                fontSize: '16px',
                fontWeight: 600,
                lineHeight: '20px'
              }}
            >
              {title}
            </h3>
          )}
          {description && (
            <p style={{margin: 0, fontSize: '14px', color: '#666666ff'}}>
              {description}
            </p>
          )}
        </div>
      </div>
      <Button
        variant="default"
        size="icon"
        onClick={onButtonClick}
        className="flex h-[44px] w-[44px] min-w-[44px] self-center p-0"
        aria-label="Legg til"
      >
        <PlusIcon className="color-primary-base" />
      </Button>
    </div>
  );
};

export {CategoryCardSmall};
export type {CategoryCardSmallProps};
